<template>
  <SpmFunc
    :url="dateObject.url"
    spm="1003.2449.3001.7932"
    :index="index"
    :view="spmView"
    :report="spmClick"
  >
    <div class="special-item">
      <div class="special-content-img">
        <img :src="dateObject.logo" class="module-click" alt="special" />
      </div>
      <div class="special-detailed">
        <p class="module-click">{{ dateObject.courseName }}</p>
        <span>购买时间{{ dateObject.expireTime }}</span>
        <div class="special-detailed-button">
          <button class="special-class-detailed">
            开始学习
            <img src="@/assets/imgs/Course/Special/ic_left.png" alt />
          </button>
        </div>
      </div>
    </div>
  </SpmFunc>
</template>

<script>
import SpmFunc from "@/components/Base/SpmFunc.vue";

export default {
  components: {
    SpmFunc,
  },
  props: {
    dateObject: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  computed: {
    spmView() {
      let temp = {
        spm: "1003.2449.3001.7932",
        dest: this.dateObject.url,
        index: this.index,
      };
      return temp;
    },
    spmClick() {
      let temp = {
        spm: "1003.2449.3001.7932",
        dest: this.dateObject.url,
        index: this.index,
      };
      return temp;
    },
  },
};
</script>

<style lang="less" scoped>
.special-item {
  display: flex;
  margin-bottom: 16px;
  cursor: pointer;

  .special-content-img {
    position: relative;
    width: 156px;
    height: 88px;
    background: #f5f6f7;
    border-radius: 2px;
    margin-right: 12px;

    img {
      width: 156px;
      height: 88px;
      border-radius: 2px;
      object-fit: cover;
    }
  }
  .special-detailed {
    position: relative;

    p {
      width: 598px;
      font-size: 14px;
      font-weight: 500;
      color: #555666;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 24px;
      margin-top: 4px;
    }
    span {
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: #555666;
      line-height: 16px;
    }
    .special-detailed-button {
      position: absolute;
      bottom: 0;
      right: 0;

      button {
        display: flex;
        align-items: center;
        width: 64px;
        height: 24px;
        background: #ffffff;
        border: 0;
        font-size: 12px;
        font-weight: 400;
        color: #222226;
        line-height: 16px;

        img {
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .special-detailed {
      width: calc(~"100% - 168px") !important;
    }
  }
}
</style>